import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const EditDirections = () => {
  return (
    <Edit
      title="Редакция на направление"
      mutationMode="pessimistic"
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditDirections;
